/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MonitoredObjectOperationalCosts,
    MonitoredObjectOperationalCostsFromJSON,
    MonitoredObjectOperationalCostsFromJSONTyped,
    MonitoredObjectOperationalCostsToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectOperationalCost
 */
export interface ReadOnlyMonitoredObjectOperationalCost {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectOperationalCost
     */
    readonly id?: number;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMonitoredObjectOperationalCost
     */
    dateFrom?: Date;
    /**
     * 
     * @type {MonitoredObjectOperationalCosts}
     * @memberof ReadOnlyMonitoredObjectOperationalCost
     */
    costs: MonitoredObjectOperationalCosts;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMonitoredObjectOperationalCost
     */
    dateTo?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectOperationalCost
     */
    monitoredObject: number;
}

export function ReadOnlyMonitoredObjectOperationalCostFromJSON(json: any): ReadOnlyMonitoredObjectOperationalCost {
    return ReadOnlyMonitoredObjectOperationalCostFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectOperationalCostFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectOperationalCost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'dateFrom': !exists(json, 'date_from') ? undefined : (new Date(json['date_from'])),
        'costs': MonitoredObjectOperationalCostsFromJSON(json['costs']),
        'dateTo': !exists(json, 'date_to') ? undefined : (json['date_to'] === null ? null : new Date(json['date_to'])),
        'monitoredObject': json['monitored_object'],
    };
}

export function ReadOnlyMonitoredObjectOperationalCostToJSON(value?: ReadOnlyMonitoredObjectOperationalCost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date_from': value.dateFrom === undefined ? undefined : (value.dateFrom.toISOString()),
        'costs': MonitoredObjectOperationalCostsToJSON(value.costs),
        'date_to': value.dateTo === undefined ? undefined : (value.dateTo === null ? null : value.dateTo.toISOString()),
        'monitored_object': value.monitoredObject,
    };
}


